import { NavLink } from 'react-router-dom';
import icon_hamburger from '../../assets/icons/icon_hamburger_blue.svg';
import sampark from '../../assets/icons/sampark.svg';
import { SAMPARK_ROUTE } from '../../constants/routes';
import { useHeaderTabs } from '../../v2/hooks/useHeaderTabs';
import { useSideNavStyles } from './SideNav.styles';
import { Link } from '@mui/material';
import { ENV } from '../../config/config.constants';
import { iconHome } from '../../assets/icons/icon-home';

interface ISideNav {
  isExpanded: boolean;
  toggleExpanded: () => void;
}

export const SideNav = ({ isExpanded, toggleExpanded }: ISideNav) => {
  const tabValues: SAMPARK_ROUTE[] = useHeaderTabs();
  const { classes } = useSideNavStyles();

  return (
    <div className="sideNav-sampark">
      <a className={classes.link} key={'top'}>
        <div onClick={toggleExpanded} className={classes.linkContainer}>
          <div className={classes.topIconContainer}>
            <img src={icon_hamburger} />
          </div>
          {isExpanded ? (
            <div className={classes.topIconContainer}>
              <img src={sampark} className={classes.samparkIcon} />
            </div>
          ) : null}
        </div>
      </a>
      {tabValues.map((tab: any) => {
        // Routes with no legacy component (component: null) only exist in sampark-new —
        // use a plain anchor so the browser does a full page navigation instead of a
        // client-side React Router transition (which would 404 in the legacy app).
        // Other routes with a `newAppUrl` set are dual-implemented and aren't migrated
        // yet, so they stay on the legacy router.
        if (tab.newAppUrl && !tab.component) {
          return (
            <Link key={tab.newAppUrl} href={tab.newAppUrl} className={classes.link}>
              <div className={classes.linkContainer}>
                <div className={classes.icon}>{tab.icon({ stroke: 'currentColor' })}</div>
                {isExpanded ? <span className={classes.text}> {tab.name} </span> : null}
              </div>
            </Link>
          );
        }
        return (
          <NavLink
            key={tab.value}
            to={tab.value}
            className={classes.link}
            activeClassName={classes.activeLink}
          >
            <div className={classes.linkContainer} key={tab.value}>
              <div className={classes.icon}>{tab.icon({ stroke: 'currentColor' })}</div>
              {isExpanded ? <span className={classes.text}> {tab.name} </span> : null}
            </div>
          </NavLink>
        );
      })}
      {ENV === 'development' || ENV === 'local' ? (
        <Link href={'/app'} className={classes.link}>
          <div className={classes.linkContainer}>
            <div className={classes.icon}>{iconHome({ stroke: 'currentColor' })}</div>
            {isExpanded ? <span className={classes.text}> {'New App'} </span> : null}
          </div>
        </Link>
      ) : null}
    </div>
  );
};
